// @owners { team: patients }
import { useCartData } from './useCartData';
import { getCartPricingTotals } from '~shared/features/cart/selectors/getCartDetails';
import { type ItemPriceTotal } from '~shared/features/pricing/selectors/getPricingInfoForPrescription';
import { type OrderPricing } from '~shared/features/pricing/types';
import { useOrderPricing } from '~shared/queries';

type UseCartPricingTotals = {
  cartPricingTotals: Record<number, ItemPriceTotal>;
};

export const useCartPricingTotalsInitialState: UseCartPricingTotals = {
  cartPricingTotals: {},
};

const DEFAULT_ORDER_PRICING: OrderPricing = {
  line_items: [],
  item_pricing: {},
  metadata: {
    estimated: false,
    expensive: false,
  },
};

export const useCartPricingTotals = () => {
  const { cartItems, updatedAt: cartUpdatedAt } = useCartData();
  const { orderPricing, lastFetchedAt } = useOrderPricing();

  const { cartPricingTotals } = getCartPricingTotals({
    cartItems,
    orderPricing: orderPricing ?? DEFAULT_ORDER_PRICING,
    cartUpdatedAt,
    orderPricingUpdatedAt: lastFetchedAt,
  });

  return { cartPricingTotals };
};
